import { Box, Button, useTheme } from '@mui/material';
import { useFetchDocumentByStatus } from '../../../../hooks/useFetchDocumentByStatus';
import { useState } from 'react';

export const FilterDocuments = ({ token, onFilterResult, onFilterLoading }) => {
  const theme = useTheme();
  const { fetchByStatus } = useFetchDocumentByStatus(token);
  
  const [, setActiveFilter] = useState('activos');

  const handleFilter = async (status, filterName) => {
    setActiveFilter(filterName);
    if (onFilterLoading) onFilterLoading(true);
    const data = await fetchByStatus(status);
    if (data && onFilterResult) {
      onFilterResult(data.data, filterName);
    }
    if (onFilterLoading) onFilterLoading(false);
  };

  const buttonSx = {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
      <Button
        variant="contained"
        disableElevation
        onClick={() => handleFilter(undefined, 'total')}
        sx={{
          ...buttonSx,
          backgroundColor: theme.palette.grey[900],
          "&:hover": { backgroundColor: theme.palette.grey[800] },
        }}
      >
        Total
      </Button>

      <Button
        variant="contained"
        disableElevation
        onClick={() => handleFilter(1, 'activos')}
        sx={{
          ...buttonSx,
          backgroundColor: theme.palette.success.main,
          "&:hover": { backgroundColor: theme.palette.success.dark },
        }}
      >
        Activos
      </Button>

      <Button
        variant="contained"
        disableElevation
        onClick={() => handleFilter(0, 'inactivos')}
        sx={{
          ...buttonSx,
          backgroundColor: theme.palette.error.main,
          "&:hover": { backgroundColor: theme.palette.error.dark },
        }}
      >
        Inactivos
      </Button>
    </Box>
  );
};
